import { render, staticRenderFns } from "./BatchNumberAdd.vue?vue&type=template&id=3b8baf38&scoped=true&"
import script from "./BatchNumberAdd.vue?vue&type=script&lang=js&"
export * from "./BatchNumberAdd.vue?vue&type=script&lang=js&"
import style0 from "./BatchNumberAdd.vue?vue&type=style&index=0&id=3b8baf38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8baf38",
  null
  
)

export default component.exports